var _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 144,
    viewBox: "0 0 141 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 81,
    r: 60,
    fill: "#F7F3FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72 128C97.9574 128 119 106.957 119 81C119 55.0426 97.9574 34 72 34C46.0426 34 25 55.0426 25 81C25 106.957 46.0426 128 72 128Z",
    fill: "#3CAF47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 116C91.33 116 107 100.33 107 81C107 61.67 91.33 46 72 46C52.67 46 37 61.67 37 81C37 100.33 52.67 116 72 116Z",
    fill: "#3CAF47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4386 95.0217C65.6553 95.0217 64.9111 94.7083 64.3628 94.16L53.2786 83.0758C52.1428 81.94 52.1428 80.06 53.2786 78.9242C54.4145 77.7884 56.2945 77.7884 57.4303 78.9242L66.4386 87.9325L86.5703 67.8008C87.7061 66.665 89.5861 66.665 90.722 67.8008C91.8578 68.9367 91.8578 70.8167 90.722 71.9525L68.5145 94.16C67.9661 94.7083 67.222 95.0217 66.4386 95.0217Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 39,
    r: 7,
    fill: "#3CAF47"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 137,
    r: 7,
    fill: "#3CAF47"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 7,
    r: 7,
    fill: "#3CAF47"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 132,
    r: 4,
    fill: "#3CAF47"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 50,
    r: 4,
    fill: "#3CAF47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.b8841da4a59155cfb14d931b45f61fa2.svg";
export { ForwardRef as ReactComponent };